import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { GetStaticProps, GetStaticPaths } from 'next'
import dynamic from 'next/dynamic'
import { Amplitude, LogOnMount } from '@amplitude/react-amplitude'

const Blogpost = dynamic(() => import('../../src/components/Post'))
import { Post as IPost } from '../../types/post'
import { urls } from '../../src/utils/config'
import Nav from '../../src/components/Nav'
import Footer from '../../src/components/Footer'
interface Props {
  post: IPost
}

function TutorialPost({ post }: Props): JSX.Element {
  const { pathname } = useRouter()
  const url = `${urls.blog}/${post?.slug}`
  const currentUrl = `${process.env.NEXT_PUBLIC_APP_URL}${url}`

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  if (!post) {
    return <div>Not Found</div>
  }
  return (
    <Amplitude
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      eventProperties={(inheritedProps: { page: any }) => ({
        ...inheritedProps,
        page: {
          ...inheritedProps.page,
          name: url,
        },
      })}
    >
      {(): JSX.Element => (
        <>
          <LogOnMount eventType="page-displayed" />
          <NextSeo
            title={post?.seo_title}
            description={post?.seo_description}
            openGraph={{
              url: currentUrl,
              title: post?.seo_title,
              description: post?.seo_description,
              images: post?.sharing_image && [
                {
                  url: post?.sharing_image.url,
                  width: 1200,
                  height: 630,
                  alt: `${post?.title} image - Cryptotesters.com`,
                },
              ],
              site_name: 'Cryptotesters.com',
            }}
            twitter={{
              handle: '@cryptotesters',
              site: '@cryptotesters',
              cardType: 'summary_large_image',
            }}
          />
          <Nav />
          <Blogpost post={post} currentUrl={currentUrl} />
          <Footer />
        </>
      )}
    </Amplitude>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  const response = await fetch(`${process.env.NEXT_PUBLIC_STRAPI_URL}/posts`)
  const data = (await response.json()) as IPost[]
  const preRenderedPosts = data.map((post) => ({
    params: { slug: post.slug },
  }))
  return {
    paths: preRenderedPosts,
    fallback: true,
  }
}

export const getStaticProps: GetStaticProps = async (context) => {
  const slug = context.params?.slug
  const response = await fetch(`${process.env.NEXT_PUBLIC_STRAPI_URL}/posts?slug=${slug}`)
  const data = (await response.json()) as IPost[]
  const post = data[0]
  return {
    props: {
      post,
    },
  }
}

export default TutorialPost
